import { createPath, parsePath } from "history";
import { TAB_QUERY } from "portal/utils/routing";

export enum PlantProfileTab {
  ALL = "all",
  CATEGORIZED = "categorized",
  HISTORY = "history",
}

export type PlantProfileViewTab =
  | typeof PlantProfileTab.CATEGORIZED
  | typeof PlantProfileTab.HISTORY;

export type PlantProfileEditTab =
  | typeof PlantProfileTab.ALL
  | typeof PlantProfileTab.CATEGORIZED;

export const withPlantProfileTabQuery = (
  path: string,
  tab: PlantProfileTab
): string => {
  const { pathname = "", search, hash } = parsePath(path);
  const params = new URLSearchParams(search);
  params.set(TAB_QUERY, tab);
  const query = params.toString();
  return createPath({
    pathname,
    search: query ? `?${query}` : "",
    hash,
  });
};

/** Resolve a URL tab param to the tab allowed for the current mode. */
export const resolvePlantProfileTab = (
  isEditing: boolean,
  tabParam: PlantProfileTab | undefined
): PlantProfileTab => {
  if (isEditing) {
    if (
      tabParam === PlantProfileTab.ALL ||
      tabParam === PlantProfileTab.CATEGORIZED
    ) {
      return tabParam;
    }
    return PlantProfileTab.ALL;
  }
  if (tabParam === PlantProfileTab.HISTORY) {
    return PlantProfileTab.HISTORY;
  }
  return PlantProfileTab.CATEGORIZED;
};

/** Tab to keep when leaving edit for view. */
export const tabForPlantProfileViewLeave = (
  tab: PlantProfileTab
): PlantProfileTab =>
  tab === PlantProfileTab.CATEGORIZED || tab === PlantProfileTab.HISTORY
    ? tab
    : PlantProfileTab.CATEGORIZED;
